import * as React from 'react';

import { cn } from '@/lib/utils';

interface FormErrorProps extends React.HTMLAttributes<HTMLParagraphElement> {
  message?: string;
}

const FormError = React.forwardRef<HTMLParagraphElement, FormErrorProps>(
  ({ message, className, ...props }, ref) => (
    <p
      ref={ref}
      className={cn(
        'text-destructive min-h-5 text-sm',
        !message && 'invisible',
        className,
      )}
      {...props}
    >
      {message}
    </p>
  ),
);
FormError.displayName = 'FormError';

export { FormError };
